import React from "react";
import { array, bool, object, string } from "prop-types";
import { get } from "lodash";

import CardImage from "../CardImage";
import NewsHeadline from "../NewsHeadline";
import Anchor from "../Anchor";
import Excerpt from "../../atoms/Excerpt";
import StoryMetaData from "../../molecules/StoryMetaData";
import SponsorDetails from "../../molecules/SponsorDetails";

import { getExcerpt } from "../../utils/utils";

import "./focusedCard.m.css";

const FocusedCard = ({
  story,
  className = "",
  showSection = true,
  aspectRatio = [3, 2],
  imageType = "image3x2",
  collectionOfCollection,
  widths = [250, 480, 764],
}) => {
  if (!story) return null;

  const { headline, url } = story;
  const excerpt = getExcerpt(story);
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  const showLiveBlog = story["story-template"] === "live-blog";
  const sponsor = sponsorId && !showLiveBlog;

  const section = story.sections?.[0];
  const tag = story.tags?.[0];

  const getMetaInfo = () => {
    if (!collectionOfCollection && tag) {
      return (
        <div styleName="section-link">
          <Anchor aria-label={tag.name} href={`/topic/${tag.slug}`} styleName="name">
            {tag.name}
          </Anchor>
        </div>
      );
    } else if (collectionOfCollection && section) {
      const { "display-name": sectionDisplayName = "", name = "", slug = "" } = section;

      return (
        <div styleName="section-link">
          <Anchor href={slug} aria-label={sectionDisplayName || name} styleName="name">
            {sectionDisplayName || name}
          </Anchor>
        </div>
      );
    } else return null;
  };

  return (
    <div className={`${className} focused-card`} styleName="base">
      <div aria-label={headline} styleName="wrapper">
        <CardImage
          className="card-with-image-zoom"
          story={story}
          aspectRatio={aspectRatio}
          imageType={imageType}
          linkEnable={true}
          widths={widths}
        />
        <div styleName="text-wrapper">
          {showSection && getMetaInfo()}
          <NewsHeadline story={story} cssStyleName="mediumBigSize" />
          {excerpt && <Excerpt excerpt={excerpt} url={url} />}
          {!sponsor && <StoryMetaData story={story} />}
          {sponsor && <SponsorDetails sponsorId={sponsorId} showImage={false} />}
        </div>
      </div>
    </div>
  );
};

FocusedCard.propTypes = {
  className: string,
  story: object,
  showSection: bool,
  imageType: string,
  aspectRatio: array,
  collectionOfCollection: bool,
  widths: array,
};

export default FocusedCard;
